module.exports = __webpack_public_path__ + "../static/img/fair.b0da8cfe.png";